import { inject, Injectable } from '@angular/core';
import { SlugService } from './slug.service';
import { LanguageService } from './language.service';
import { CartItem } from './cart.service';
import { ProductService } from './product.service';

declare global {
    interface Window {
        umami: {
            track(event: string, payload?: { [key: string]: any }): void;
        };
    }
}

@Injectable({
    providedIn: 'root',
})
export class UmamiService {
    slugService = inject(SlugService);
    languageService = inject(LanguageService);
    productService = inject(ProductService);

    track(event: string, payload?: { [key: string]: any }) {
        try {
            window.umami.track(event, {
                ...payload,
                slug: this.slugService.getSlug(),
                languageCode: this.languageService.getLanguageCode,
            });
        } catch (e) {
            console.log('Error tracking event', e);
        }
    }

    getCartItemPayload(item: CartItem) {
        return {
            product: item.product.name,
            amount: item.amount,
            variant: this.productService.getVariantLabel(
                item.product,
                item.selectedVariant,
            ),
            deliveryDate: item.selectedDeliveryDate?.date,
        };
    }

    getCartPayload(cartItems: CartItem[]) {
        return cartItems.map((item) => this.getCartItemPayload(item));
    }
}
